import Grid from '@mui/material/Grid';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { FormInputTime } from '../../../components/hook-form/form-input.time.component';

export const ServiceGroupForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Service Group Name" name="serviceGroupName" maxLength={150} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Description" name="description" maxLength={150} multiline={true} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInputTime name="cutOffTime" label="Cut-off Time" />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
          <FormCheckbox label="Active" name="isActive" />
        </Grid>
      </Grid>
    </Grid>
  );
};
